<template>
  <div style="background: #f7f7f7">
    <br />
    <br />
    <v-container fluid class="ml-10 mr-10">
      <v-row align="center" justify="center">
        <v-col lg="7" md="7" sm="12" cols="12" class="pl-10 pr-10">
          <p class="title text-center">{{titulos[0]}}</p>
          <h1 class="subtitle-1 text-left pb-2">{{titulos[1]}}</h1>
          <v-select
            :items="tipoOrg"
            label="Organización"
            v-model="TipoOrgSelected"
            dense
            outlined
            class="text-right"
          ></v-select>
          <h1 class="subtitle-1 text-left pb-2">{{titulos[7]}}</h1>
          <v-select
            :items="tipoSuscrip"
            @change="CambiarHorasTotales()"
            label="Suscripcion"
            v-model="TipoSuscipcionSelected"
            dense
            outlined
            class="text-right"
          ></v-select>
          <h1 class="subtitle-1 text-left pl-2">{{titulos[6]}}</h1>
          <v-slider
            v-model="sliderHrsSimultaneas"
            :max="max[3]"
            color="#E8175D"
            track-color="grey lighten-1"
            :min="min[3]"
            hide-details
            thumb-label="always"
          ></v-slider>
          <br />
          <br />
          <h1 class="subtitle-1 text-left pl-2">{{titulos[2]}}</h1>
          <v-slider
            v-model="sliderBaja"
            :max="max[0]"
            color="#E8175D"
            @end="SumarTotales()"
            track-color="grey lighten-1"
            :min="min[0]"
            hide-details
            thumb-label="always"
          ></v-slider>
          <h1 class="subtitle-1 text-left pl-2">{{titulos[3]}}</h1>
          <v-slider
            v-model="sliderMedia"
            :max="max[1]"
            color="#E8175D"
            @end="SumarTotales()"
            track-color="grey lighten-1"
            :min="min[1]"
            hide-details
            thumb-label="always"
          ></v-slider>
          <h1 class="subtitle-1 text-left pl-2">{{titulos[4]}}</h1>
          <v-slider
            v-model="sliderAlta"
            :max="max[2]"
            color="#E8175D"
            @end="SumarTotales()"
            track-color="grey lighten-1"
            :min="min[2]"
            hide-details
            thumb-label="always"
          ></v-slider>
          <h1 class="subtitle-1 text-right pl-2">{{titulos[5]}}</h1>
          <p class="subtitle-1 font-weight-bold text-right">{{totalhoras}}</p>
          <div class="text-center">
            <v-btn
              class="ma-2 white--text"
              :loading="loading2"
              :disabled="loading2"
              color="#E8175D"
              width="150"
              @click="loader = 'loading2'"
            >
              Calcular
              <template v-slot:loader>
                <span>Calculando...</span>
              </template>
            </v-btn>
          </div>
        </v-col>
        <v-col lg="5" md="5" sm="12" cols="12">
          <div style="height: 650px; background: #E8175D; width: 600px" class="mr-10">
            <br />
            <br />
            <p class="display-2 text-center white--text">
              {{valorMensual}} USD/
              <span class="headline">MES</span>
            </p>
            <br />
            <br />
            <v-row class="pl-10 pr-10">
              <h4 left class="subtitle-1 white--text">{{textouno}}</h4>
              <v-spacer></v-spacer>
              <h4 class="subtitle-1 white--text">{{valortextouno}}</h4>
              <br />
              <br />
            </v-row>
            <v-row class="pl-10 pr-10">
              <h4
                class="subtitle-1 white--text"
              >Capacitación Operación de Telescopios y Plataforma Web</h4>
              <v-spacer></v-spacer>
              <h4 class="subtitle-1 white--text">$0</h4>
              <br />
              <br />
            </v-row>
            <v-row class="pl-10 pr-10">
              <h4 class="subtitle-1 white--text">Curso introductorio de Astrofotografia</h4>
              <v-spacer></v-spacer>
              <h4 class="subtitle-1 white--text">$0</h4>
              <br />
              <br />
            </v-row>
            <v-row class="pl-10 pr-10">
              <h4 class="subtitle-1 white--text text-left">Visita a Observatorio</h4>
              <v-spacer></v-spacer>
              <h4 class="subtitle-1 white--text text-center">$0</h4>
              <br />
              <br />
              <br />
              <br />
            </v-row>
            <v-row class="pl-10 pr-10">
              <h4 class="subtitle-1 white--text text-left font-weight-bold">Total Suscripción</h4>
              <v-spacer></v-spacer>
              <h4 class="title white--text text-center font-weight-bold">{{valorTotal}} USD</h4>
              <br />
              <br />
              <br />
              <br />
            </v-row>
            <div class="text-center">
              <v-btn large color="white" style="color: black">Contratar</v-btn>
            </div>
            <p class="caption pt-3 text-center white--text font-italic">
              <v-icon
                style="cursor: pointer"
                @click="dialogModal = !dialogModal"
                small
                color="white"
              >mdi-help</v-icon>Ver valores referenciales
              <ModalPrecios :dialogProps="dialogModal" @respModal="dialogModal = $event" />
            </p>
            <h2 class="caption font-italic white--text text-center">
              * Sujeto a disponibilidad, leer
              <strong style="cursor: pointer">condiciones</strong>
            </h2>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ModalPrecios from "../components/Modals/ModalPrecios";

function number_format(amount, decimals) {

    amount += ''; // por si pasan un numero en vez de un string
    amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto

    decimals = decimals || 0; // por si la variable no fue fue pasada

    // si no es un numero o es igual a cero retorno el mismo cero
    if (isNaN(amount) || amount === 0) 
        return parseFloat(0).toFixed(decimals);

    // si es mayor o menor que cero retorno el valor formateado como numero
    amount = '' + amount.toFixed(decimals);

    var amount_parts = amount.split('.'),
        regexp = /(\d+)(\d{3})/;

    while (regexp.test(amount_parts[0]))
        amount_parts[0] = amount_parts[0].replace(regexp, '$1' + ',' + '$2');

    return amount_parts.join('.');
}

export default {
  data() {
    return {
      totalhoras: 0,
      TipoOrgSelected: "",
      TipoSuscipcionSelected: "",
      show: true,
      dialogModal: false,
      sliderBaja: 0,
      sliderMedia: 0,
      sliderAlta: 0,
      sliderHrsSimultaneas: 30,
      min: [0, 0, 0, 2],
      max: [1020, 624, 876, 60],
      valorMensual: 0,
      valorTotal: 0,
      textouno: '',
      valortextouno: '',
      loading2: false,
      loader: null,
      titulos: [
        "Calcula tu Suscripción",
        "Tipo Organización",
        "Horas luminocidad baja <= 20%",
        "Horas luminocidad media > 20% y <=45%",
        "Horas luminocidad alta >45% y <=80%",
        "Total Horas",
        "Conexiones Simultaneas",
        "Tipo Suscripción"
      ],
      tipoOrg: ["Escuela/Colegio", "Universidad", "Grupo de Investigación"],
      tipoSuscrip: ["Semestral", "Anual"]
    };
  },
  watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (
          this.CalcularTotal(),
          this[l] = false
          ), 3000)

        this.loader = null

      }

  },
  components: {
    ModalPrecios
  },
  methods: {
    SumarTotales() {
      this.totalhoras = this.sliderBaja + this.sliderMedia + this.sliderAlta;
    },
    CalcularTotal() {

      let valorhora = 75;
      let valorHoraUno = 100;
      let valorHoraDos = 120;
      let valorHoraTres = 180;
      let cantHorasAnual = 2520;
      let descuentoUno = 1 - 0.25;
      let descuentoDos = 1 - 0.5;
      let descuentoOrg = 1 - 0.05;
      let cantHorasSemestral = 1308;
      let preciofinal = 0;

      let valorLumiBaja = 0;
      let valorLumiMedia = 0;
      let valorLumiAlta = 0;

      switch (this.TipoOrgSelected) {
        case "Escuela/Colegio":
          preciofinal = this.totalhoras * valorhora;
          this.valorTotal = number_format(preciofinal, 1);

           if (this.TipoSuscipcionSelected === "Semestral") {
            this.valorMensual = number_format((preciofinal / 6), 1);
          } else {
            this.valorMensual = number_format((preciofinal / 12), 1);
          }

          this.textouno = 'Precio Promocional';
          this.valortextouno = '75 USD/Hora';

          return "";
        case "Universidad":
          // hasta 5 conexiones
          if (
            this.sliderHrsSimultaneas >= 2 &&
            this.sliderHrsSimultaneas <= 5
          ) {
            valorLumiBaja = this.sliderBaja * valorHoraUno;
            valorLumiMedia = valorHoraUno * descuentoUno * this.sliderMedia;
            valorLumiAlta = valorHoraUno * descuentoDos * this.sliderAlta;
            preciofinal = valorLumiBaja + valorLumiMedia + valorLumiAlta;
            this.valorTotal = number_format(preciofinal, 1);
          }
          //mayor de 5 y hasta 15 conexiones
          else if (
            this.sliderHrsSimultaneas > 5 &&
            this.sliderHrsSimultaneas <= 15
          ) {
            valorLumiBaja = this.sliderBaja * valorHoraDos;
            valorLumiMedia = valorHoraDos * descuentoUno * this.sliderMedia;
            valorLumiAlta = valorHoraDos * descuentoDos * this.sliderAlta;
            preciofinal = valorLumiBaja + valorLumiMedia + valorLumiAlta;
            this.valorTotal = number_format(preciofinal, 1);
          }
          // mas de 15 conexiones
          else {
            valorLumiBaja = this.sliderBaja * valorHoraTres;
            valorLumiMedia = valorHoraTres * descuentoUno * this.sliderMedia;
            valorLumiAlta = valorHoraTres * descuentoDos * this.sliderAlta;
            preciofinal = valorLumiBaja + valorLumiMedia + valorLumiAlta;
            this.valorTotal = number_format(preciofinal, 1);
          }

           if (this.TipoSuscipcionSelected === "Semestral") {
            this.valorMensual = number_format((preciofinal / 6), 1);
          } else {
            this.valorMensual = number_format((preciofinal / 12), 1);
          }

          this.textouno = '';
          this.valortextouno = '';

          return "";
        case "Grupo de Investigación":
          // hasta 5 conexiones
          if (
            this.sliderHrsSimultaneas >= 2 &&
            this.sliderHrsSimultaneas <= 5
          ) {
            valorLumiBaja = this.sliderBaja * valorHoraUno;
            valorLumiMedia = valorHoraUno * descuentoUno * this.sliderMedia;
            valorLumiAlta = valorHoraUno * descuentoDos * this.sliderAlta;
            preciofinal = valorLumiBaja + valorLumiMedia + valorLumiAlta;
          }
          //mayor de 5 y hasta 15 conexiones
          else if (
            this.sliderHrsSimultaneas > 5 &&
            this.sliderHrsSimultaneas <= 15
          ) {
            valorLumiBaja = this.sliderBaja * valorHoraDos;
            valorLumiMedia = valorHoraDos * descuentoUno * this.sliderMedia;
            valorLumiAlta = valorHoraDos * descuentoDos * this.sliderAlta;
            preciofinal = valorLumiBaja + valorLumiMedia + valorLumiAlta;
          }
          // mas de 15 conexiones
          else {
            valorLumiBaja = this.sliderBaja * valorHoraTres;
            valorLumiMedia = valorHoraTres * descuentoUno * this.sliderMedia;
            valorLumiAlta = valorHoraTres * descuentoDos * this.sliderAlta;
            preciofinal = valorLumiBaja + valorLumiMedia + valorLumiAlta;
          }
          preciofinal = preciofinal * descuentoOrg;
          this.valorTotal = number_format(preciofinal, 1)

          if (this.TipoSuscipcionSelected === "Semestral") {
            this.valorMensual = number_format((preciofinal / 6), 1);
          } else {
            this.valorMensual = number_format((preciofinal / 12), 1);
          }

          this.textouno = 'Descuento Grupo de Investigación';
          this.valortextouno = '5%';

          return "";
      }

    },
    CambiarHorasTotales() {
      if (this.TipoSuscipcionSelected === "Anual") {
        this.max[0] = 1020;
        this.max[1] = 624;
        this.max[2] = 876;
      } else {
        this.max[0] = 540;
        this.max[1] = 336;
        this.max[2] = 432;
      }
    }
  }
};
</script>

<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    font-size: 10px;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>